import { useLayout } from "@/lib/preFetch/preFetchLayout";
import { ChevronDown, Link, Select, SelectContent, SelectIcon, SelectItem, SelectTrigger, SelectValue, useI18n, } from "@jog/react-components";
import { asLink } from "@prismicio/helpers";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
export const CountrySwitcher = () => {
    const layout = useLayout();
    const type = layout.layout.footer.localeSwitch.type || "select";
    const [fold, setFold] = useState(true);
    const { $t } = useI18n();
    const list = layout.layout.localeSwitch.filter((i) => i.countryCode !== "US");
    const [value, setValue] = useState(process.env.NEXT_PUBLIC_COUNTRY === "US" ? list[0].countryCode : process.env.NEXT_PUBLIC_COUNTRY);
    const current = list.find((i) => i.countryCode === value);
    if (type === "select") {
        return (<div className="flex justify-between lg:block">
                <div className="mb-0 mt-2 flex font-primary text-sm font-medium uppercase text-gray-dracula lg:mt-0 lg:mb-3.75">
                    {layout.layout.footer.localeSwitch.title}
                </div>
                <div className="relative inline-block">
                    <Select value={value} onValueChange={(v) => {
                var _a;
                setValue(v);
                const link = (_a = list.find((i) => i.countryCode === v)) === null || _a === void 0 ? void 0 : _a.link;
                if (link) {
                    window.location.href = asLink(link);
                }
            }}>
                        <SelectTrigger aria-label="Country switcher" className="block w-full appearance-none rounded-lg border-none py-2 pr-7 text-sm focus:outline-none">
                            <SelectValue>{current === null || current === void 0 ? void 0 : current.name}</SelectValue>
                            <SelectIcon asChild>
                                <ChevronDown className="size-4 group pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 text-black" aria-hidden="true" strokeWidth={2}/>
                            </SelectIcon>
                        </SelectTrigger>
                        <SelectContent position="popper" className="relative z-50 overflow-hidden border border-gray-medium bg-white text-black data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1">
                            {list.map((field) => (<SelectItem className="relative flex w-full cursor-pointer select-none items-center py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-gray-bg" key={field.countryCode} value={field.countryCode}>
                                    {$t(field.name)}
                                </SelectItem>))}
                        </SelectContent>
                    </Select>
                </div>
            </div>);
    }
    else {
        return (<AnimatePresence mode="sync">
                <div>
                    <div className="mb-0 mt-2 flex w-full items-center justify-between font-primary text-sm font-medium uppercase text-gray-dracula lg:mt-0 lg:mb-3.75">
                        <div>{layout.layout.footer.localeSwitch.title}</div>
                        <div className="flex h-6 items-center pl-8 lg:hidden" onClick={() => setFold((v) => !v)}>
                            <motion.span transition={{ duration: 0.3, ease: [0.55, 0.055, 0.675, 0.19] }} animate={fold ? "close" : "open"} variants={{ open: { rotate: "180deg" }, close: { rotate: "0deg" } }}>
                                <ChevronDown strokeWidth={2}/>
                            </motion.span>
                        </div>
                    </div>
                    <motion.ul transition={{ duration: 0.3, ease: [0.55, 0.055, 0.675, 0.19] }} animate={fold ? "close" : "open"} variants={{ open: { height: "auto" }, close: { height: 0 } }} className="overflow-hidden lg:!h-auto">
                        {list.map((item) => (<li className="py-2 text-sm" key={item.countryCode}>
                                <Link className="hover:underline" href={asLink(item.link)}>
                                    {$t(item.name)}
                                </Link>
                            </li>))}
                    </motion.ul>
                </div>
            </AnimatePresence>);
    }
};
